import { action } from 'satcheljs';
import type {
    PageContext,
    SortDirection,
    SubstrateSearchResponse,
    SubstrateSearchRequest,
    SuggestionKind,
    Provenance,
} from 'owa-search-service';
import type { OwaDate } from 'owa-datetime';

/**
 * Executes the actual search query
 */
export const invokeSearch = action('invokeSearch', (
    currentPageContext: PageContext,
    searchSessionGuid: string,
    searchQueryId: string,
    queryString: string,
    entityRequestType: string,
    sortDirection: SortDirection,
    // boundSearchResultCount - false indicates, as many results as 3S can return (1025 is the Max that 3S supports),
    // true indicates specified (250 hardcoded) number of results
    boundSearchResultCount: boolean,
    queryIncludesPeopleSuggestion: boolean,
    includeOnlyItemsWithAttachments: boolean,
    includeDeletedItems: boolean,
    folderIds: string[],
    fromDate: OwaDate,
    toDate: OwaDate,
    provenances?: Provenance[]
) => ({
    currentPageContext,
    searchSessionGuid,
    searchQueryId,
    queryString,
    entityRequestType,
    sortDirection,
    boundSearchResultCount,
    queryIncludesPeopleSuggestion,
    includeOnlyItemsWithAttachments,
    includeDeletedItems,
    folderIds,
    fromDate,
    toDate,
    provenances,
}));

/**
 * Triggers a action indicating search query is complete, so the results can be processed
 */
export const searchCompleted = action(
    'searchCompleted',
    (
        searchResponse: SubstrateSearchResponse,
        error: string,
        searchRequest: SubstrateSearchRequest,
        currentPageContext: PageContext,
        searchSessionGuid: string,
        searchQueryId: string,
        searchTraceId: string,
        searchNumber: number,
        queryString: string,
        sortDirection: SortDirection,
        boundSearchResultCount: boolean,
        queryIncludesPeopleSuggestion: boolean,
        includeOnlyItemsWithAttachments: boolean,
        includeDeletedItems: boolean,
        folderIds: string[],
        fromDate: OwaDate,
        toDate: OwaDate
    ) => ({
        searchResponse,
        error,
        searchRequest,
        currentPageContext,
        searchSessionGuid,
        searchQueryId,
        searchTraceId,
        searchNumber,
        queryString,
        sortDirection,
        boundSearchResultCount,
        queryIncludesPeopleSuggestion,
        includeOnlyItemsWithAttachments,
        includeDeletedItems,
        folderIds,
        fromDate,
        toDate,
    })
);

export const invokeSuggestions = action(
    'invokeSuggestions',
    (queryStringForSuggestions: string, supportedSuggestions: SuggestionKind[]) => ({
        queryStringForSuggestions,
        supportedSuggestions,
    })
);
